<ng-container *ngIf="type == 'generic'">
  <h2 transloco="introHeaderMain">What you'll be able to do:</h2>
  <h3 transloco="introHeader" class="align-self-center">What you'll be able to do:</h3>
  <div class="list_items">
  
    <i [class]="theme.name == 'Macrotech' ? 'icon-madih-icon-exclamation-circle' : 'fas fa-calendar-check'"></i>
    <span [innerHTML]="'regIntro1' | transloco"></span>
  
    <i [class]="theme.name == 'Macrotech' ? 'icon-madih-flask' : 'fas fa-globe-americas'"></i>
    <span [innerHTML]="'regIntro2' | transloco"></span>
  
    <i [class]="theme.name == 'Macrotech' ? 'icon-madih-clinic-medical' : 'fas fa-car-side'"></i>
    <span [innerHTML]="'regIntro3' | transloco"></span>
  </div>
  
  <ng-content></ng-content>
  
  <a class="compliance" transloco="hipaaCompliant"
        (click)="openModal(complianceModal)">We're HIPAA Compliant!</a>
  
  <ng-template #complianceModal let-modal>
    <i role="button" class="close modal-close" aria-label="Close" (click)="modal.close()">
      <span class="icon-close" aria-hidden="true"></span>
    </i>
    <div class="modal-body">
      <app-compliance></app-compliance>
    </div>
  </ng-template>
</ng-container>

<ng-container *ngIf="type == 'unique'">
  
  <h1 style="margin: 20px 0px;" [innerHTML]="header | transloco">header</h1>

  <p [innerHTML]="content | transloco">content</p>

</ng-container>